import React, { useState, useEffect, useCallback } from "react";
import api, { apiError } from "../api";
import { useAuth, usePermissions } from "../AuthContext";
import { AjutorButton } from "../AjutorButton";
import { toast } from "sonner";

const PACKAGES = [5, 10, 25, 50, 100];

const unitPriceFor = (qty) => {
  if (qty <= 0) return 0;
  if (qty <= 100) return 9;
  if (qty <= 200) return 8;
  if (qty <= 300) return 7;
  if (qty <= 400) return 6;
  if (qty <= 500) return 5;
  return 4;
};

const box = { fontFamily: "Arial, sans-serif", fontSize: "12px", color: "#000000", background: "#ffffff" };
const sectionStyle = { border: "1px solid #000", padding: "12px", marginBottom: "16px", background: "#fff" };
const titleStyle = { fontWeight: "bold", fontSize: "12px", marginBottom: "10px", textTransform: "uppercase" };
const btnStyle = { fontFamily: "Arial", fontSize: "12px", color: "#000", background: "#fff", border: "1px solid #000", padding: "6px 12px", cursor: "pointer", marginRight: "6px", marginBottom: "6px" };
const btnPrimary = { ...btnStyle, background: "#000", color: "#fff", fontWeight: "bold" };
const btnRed = { ...btnStyle, background: "#cc0000", color: "#fff", fontWeight: "bold", border: "1px solid #cc0000" };
const inputStyle = { fontFamily: "Arial", fontSize: "12px", color: "#000", background: "#fff", border: "1px solid #000", padding: "4px 6px", width: "100%", boxSizing: "border-box" };

export default function LeadOrders() {
  const { isSuperAdmin } = useAuth();
  const { can } = usePermissions();
  const [qty, setQty] = useState(0);
  const [tari, setTari] = useState([]);
  const [judeteAll, setJudeteAll] = useState([]);
  const [domenii, setDomenii] = useState([]);
  const [domeniiGroups, setDomeniiGroups] = useState([]);

  const [orderTari, setOrderTari] = useState([]);
  const [orderJudete, setOrderJudete] = useState([]);
  const [orderPrincipal, setOrderPrincipal] = useState("");
  const [orderSecundare, setOrderSecundare] = useState([]);
  const [placing, setPlacing] = useState(false);
  const [orderResult, setOrderResult] = useState(null);

  const [subiect, setSubiect] = useState("");
  const [text, setText] = useState("");
  const [emTari, setEmTari] = useState([]);
  const [emJudete, setEmJudete] = useState([]);
  const [emDomenii, setEmDomenii] = useState([]);
  const [savingTpl, setSavingTpl] = useState(false);

  const [bnr, setBnr] = useState(null);
  const [vatRate, setVatRate] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);

  const loadBnr = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/bnr-rate");
      setBnr(data.rate != null ? { rate: data.rate, date: data.date, source: data.source } : null);
      setVatRate(data.vat_rate != null ? Number(data.vat_rate) : null);
    } catch (e) { /* ignore */ }
  }, []);

  const loadTari = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/tari");
      setTari(data.items || []);
    } catch (e) { /* ignore */ }
  }, []);

  const loadJudeteAll = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/judete");
      setJudeteAll(data.items || []);
    } catch (e) { /* ignore */ }
  }, []);

  const loadDomenii = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/domenii");
      setDomenii(data.items || []);
      setDomeniiGroups(data.groups || []);
    } catch (e) { /* ignore */ }
  }, []);

  const loadTemplate = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/email-template");
      setSubiect(data.subiect || "");
      setText(data.text || "");
      setEmTari(data.tari || []);
      setEmJudete(data.judete || []);
      setEmDomenii(data.domenii || []);
    } catch (e) { /* ignore */ }
  }, []);

  const loadOrders = useCallback(async () => {}, []);

  useEffect(() => {
    loadTari(); loadJudeteAll(); loadDomenii(); loadTemplate(); loadBnr();
  }, [loadTari, loadJudeteAll, loadDomenii, loadTemplate, loadBnr]);

  const unit = unitPriceFor(qty);
  const total = unit * qty;
  const vr = vatRate != null ? vatRate : 0;
  const vatEur = Math.round(total * vr) / 100;
  const totalWithVat = Math.round((total + total * vr / 100) * 100) / 100;
  const totalRon = bnr ? Math.round(totalWithVat * bnr.rate * 100) / 100 : null;

  const addPackage = (n) => setQty((q) => q + n);

  const toggle = (arr, setArr, id) => {
    if (id === "all") { setArr(["all"]); return; }
    let next = arr.filter((x) => x !== "all");
    if (next.includes(id)) next = next.filter((x) => x !== id);
    else next = [...next, id];
    setArr(next);
  };

  const handlePlaceOrder = async () => {
    if (qty <= 0) { toast.error("Alegeti numarul de contacte"); return; }
    setPlacing(true);
    try {
      const { data } = await api.post("/lead-orders/order", {
        qty, tara_ids: orderTari, judet_ids: orderJudete,
        domeniu_principal: orderPrincipal || null,
        domenii_secundare: orderSecundare,
      });
      setOrderResult(data);
      loadOrders();
      toast.success("Comanda inregistrata");
    } catch (e) {
      toast.error(apiError(e, "Eroare la inregistrarea comenzii"));
    } finally { setPlacing(false); }
  };

  const downloadProforma = async (orderId, proformaNo) => {
    if (!orderId) return;
    setDownloadingId(orderId);
    try {
      const res = await api.get(`/lead-orders/order/${orderId}/proforma.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Yvola_proforma_${proformaNo}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(apiError(e, "Eroare la descarcarea proformei"));
    } finally { setDownloadingId(null); }
  };

  const handleSaveTemplate = async () => {    setSavingTpl(true);
    try {
      await api.put("/lead-orders/email-template", {
        subiect, text, tari: emTari, judete: emJudete, domenii: emDomenii,
      });
      toast.success("Sablon salvat");
    } catch (e) {
      toast.error(apiError(e, "Eroare la salvarea sablonului"));
    } finally { setSavingTpl(false); }
  };

  const CheckList = ({ items, sel, setSel, labelKey, idKey, testid }) => (
    <div data-testid={testid} style={{ maxHeight: "160px", overflowY: "auto", border: "1px solid #000", padding: "6px" }}>
      <label style={{ display: "block", marginBottom: "4px" }}>
        <input type="checkbox" checked={sel.includes("all")} onChange={() => toggle(sel, setSel, "all")}
          data-testid={`${testid}-all`} /> Toate
      </label>
      {items.map((it) => (
        <label key={it[idKey]} style={{ display: "block", marginBottom: "2px" }}>
          <input type="checkbox" checked={sel.includes(it[idKey])} disabled={sel.includes("all")}
            onChange={() => toggle(sel, setSel, it[idKey])} /> {it[labelKey]}
        </label>
      ))}
    </div>
  );

  return (
    <div style={{ ...box, padding: "24px", minHeight: "100%" }} data-testid="lead-orders-page">
      <AjutorButton file="ajutor_hunter.pdf" />
      <p data-testid="hunter-free-week-note"
        style={{ fontFamily: "Arial", fontSize: "14px", fontWeight: "bold", color: "#cc0000", marginBottom: "12px" }}>
        Saptamana aceasta lead-urile tale sunt gratis
      </p>
      <h1 style={{ fontFamily: "Arial", fontSize: "16px", fontWeight: "bold", marginBottom: "16px" }}>
        HUNTER - COMANDA LEAD-URI
      </h1>

      <div style={sectionStyle}>
        <div style={titleStyle}>A. Numar contacte</div>
        <div>
          {PACKAGES.map((n) => (
            <button key={n} style={btnStyle} onClick={() => addPackage(n)} data-testid={`pkg-${n}`}>+{n}</button>
          ))}
          <button style={btnStyle} onClick={() => setQty(0)} data-testid="pkg-reset">Reset</button>
        </div>
        <div style={{ marginTop: "10px" }}>
          Total contacte:&nbsp;
          <input type="number" min="0" value={qty} onChange={(e) => setQty(Math.max(0, parseInt(e.target.value || "0", 10)))}
            style={{ ...inputStyle, width: "100px" }} data-testid="qty-input" />
        </div>
      </div>

      <div style={sectionStyle} data-testid="price-box">
        <div style={titleStyle}>B. Pret</div>
        <div>Pret pe contact: <b data-testid="unit-price">{unit}</b> EUR</div>
        <div>Valoare fara TVA: <b data-testid="total-price">{total}</b> EUR</div>
        <div>TVA {vatRate != null ? vatRate : "-"}%: <b data-testid="vat-price">{vatEur}</b> EUR</div>
        <div>Total EUR (cu TVA): <b data-testid="total-vat-price">{totalWithVat}</b> EUR</div>
        <div style={{ marginTop: "6px" }}>
          Curs BNR EUR/RON:&nbsp;
          {bnr
            ? <span><b data-testid="bnr-rate">{Number(bnr.rate).toFixed(2)}</b> din {bnr.date}{bnr.source === "manual" ? " (setat manual)" : ""}</span>
            : <span data-testid="bnr-missing">indisponibil (se seteaza manual in Date firma de catre superadmin)</span>}
        </div>
        {bnr && <div>Total RON (cu TVA): <b data-testid="total-ron-price">{totalRon}</b> RON</div>}
        <div style={{ marginTop: "6px", fontSize: "11px" }}>
          Grile: 1-100=9, 101-200=8, 201-300=7, 301-400=6, 401-500=5, 501+=4 EUR/contact
        </div>
      </div>

      <div style={sectionStyle}>
        <div style={titleStyle}>C. Tinta comenzii</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "10px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Tari (selectie multipla sau Toate):</div>
            <CheckList items={tari} sel={orderTari} setSel={setOrderTari} labelKey="nume" idKey="id" testid="order-tari" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Judete (selectie multipla sau Toate):</div>
            <CheckList items={judeteAll} sel={orderJudete} setSel={setOrderJudete} labelKey="nume" idKey="id" testid="order-judete" />
          </div>
        </div>
      </div>

      <div style={sectionStyle} data-testid="domenii-section">
        <div style={titleStyle}>D. Domenii de activitate</div>
        <div style={{ marginBottom: "12px" }}>
          <div style={{ marginBottom: "4px" }}>Domeniu principal (o singura alegere):</div>
          <select
            value={orderPrincipal}
            onChange={(e) => setOrderPrincipal(e.target.value)}
            style={{ ...inputStyle, width: "auto", minWidth: "340px" }}
            data-testid="domeniu-principal-select"
          >
            <option value="">-- Fara domeniu principal --</option>
            {domeniiGroups.map((g) => (
              <optgroup key={g.categorie} label={g.categorie}>
                {g.items.map((it) => (
                  <option key={it.id} value={it.id}>{it.nume}</option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>
        <div>
          <div style={{ marginBottom: "4px" }}>Domenii secundare (una sau mai multe):</div>
          {domeniiGroups.length === 0
            ? <div style={{ fontSize: "11px" }}>Domeniile se incarca...</div>
            : (
              <div data-testid="domenii-secundare" style={{ maxHeight: "260px", overflowY: "auto", border: "1px solid #000", padding: "8px", columnCount: 2, columnGap: "24px" }}>
                {domeniiGroups.map((g) => (
                  <div key={g.categorie} style={{ breakInside: "avoid", marginBottom: "8px" }}>
                    <div style={{ fontWeight: "bold", marginBottom: "3px" }}>{g.categorie}</div>
                    {g.items.map((it) => (
                      <label key={it.id} style={{ display: "block", marginBottom: "2px", opacity: orderPrincipal === it.id ? 0.4 : 1 }}>
                        <input
                          type="checkbox"
                          checked={orderSecundare.includes(it.id)}
                          disabled={orderPrincipal === it.id}
                          onChange={() => setOrderSecundare((prev) => prev.includes(it.id) ? prev.filter((x) => x !== it.id) : [...prev, it.id])}
                          data-testid={`domeniu-secundar-${it.id}`}
                        /> {it.nume}
                      </label>
                    ))}
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>

      {can("hunter", "add") && (
        <button style={{ ...btnPrimary, padding: "10px 20px" }} onClick={handlePlaceOrder} disabled={placing} data-testid="place-order-btn">
          {placing ? "Se inregistreaza..." : `Trimite comanda (${totalWithVat} EUR cu TVA, Ordin de Plata)`}
        </button>
      )}

      {orderResult && (
        <div style={{ ...sectionStyle, marginTop: "16px" }} data-testid="order-result">
          <div style={titleStyle}>Comanda inregistrata - Proforma nr. {orderResult.proforma_no}</div>
          <div>Numar comanda: <b data-testid="order-no">{orderResult.order_no}</b></div>
          <div>Numar proforma: <b data-testid="proforma-no">{orderResult.proforma_no}</b></div>
          <div>Contacte: <b>{orderResult.qty}</b></div>
          <div>Pret pe contact: <b>{orderResult.unit_price}</b> EUR</div>
          <div>Valoare fara TVA: <b data-testid="order-subtotal">{orderResult.subtotal_eur}</b> EUR</div>
          <div>TVA {orderResult.vat_rate}%: <b data-testid="order-vat">{orderResult.vat_eur}</b> EUR</div>
          <div>Total EUR: <b data-testid="order-total">{orderResult.total_eur}</b> EUR</div>
          <div style={{ marginTop: "6px" }}>
            Curs BNR EUR/RON: <b data-testid="order-bnr">{Number(orderResult.bnr_rate).toFixed(2)}</b> din {orderResult.bnr_date}
          </div>
          <div>Total RON: <b data-testid="order-total-ron">{orderResult.total_ron}</b> RON</div>
          <div style={{ marginTop: "10px" }}>
            <button style={btnRed} onClick={() => downloadProforma(orderResult.order_id, orderResult.proforma_no)} disabled={downloadingId === orderResult.order_id} data-testid="download-proforma-btn">
              {downloadingId === orderResult.order_id ? "Se genereaza..." : "Descarca proforma PDF"}
            </button>
          </div>
          <div style={{ marginTop: "8px" }}>
            Plata se face prin Ordin de Plata (transfer bancar) in contul Yvola.
          </div>
        </div>
      )}

      <div style={{ ...sectionStyle, marginTop: "24px", display: isSuperAdmin ? "block" : "none" }}>
        <div style={titleStyle}>E. Sablon email</div>
        <div style={{ marginBottom: "10px" }}>
          <div>Subiect:</div>
          <input value={subiect} onChange={(e) => setSubiect(e.target.value)} style={inputStyle} data-testid="email-subiect" />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <div>Text:</div>
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={10} style={{ ...inputStyle, resize: "vertical" }} data-testid="email-text" />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
          <div>
            <div style={{ marginBottom: "4px" }}>Tari:</div>
            <CheckList items={tari} sel={emTari} setSel={setEmTari} labelKey="nume" idKey="id" testid="email-tari" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Judete:</div>
            <CheckList items={judeteAll} sel={emJudete} setSel={setEmJudete} labelKey="nume" idKey="id" testid="email-judete" />
          </div>
          <div>
            <div style={{ marginBottom: "4px" }}>Domenii:</div>
            {domenii.length === 0
              ? <div style={{ fontSize: "11px" }}>Se vor defini ulterior.</div>
              : <CheckList items={domenii} sel={emDomenii} setSel={setEmDomenii} labelKey="nume" idKey="id" testid="email-domenii" />}
          </div>
        </div>
        <div style={{ marginTop: "12px" }}>
          <button style={btnPrimary} onClick={handleSaveTemplate} disabled={savingTpl} data-testid="save-template-btn">
            {savingTpl ? "Se salveaza..." : "Salveaza sablon"}
          </button>
          <span style={{ marginLeft: "10px", fontSize: "11px" }}>Trimiterea emailului este momentan dezactivata.</span>
        </div>
      </div>
    </div>
  );
}
